/**
 * FsCreateStepper Seata helpers — uses shared wizard tx API on audit service.
 * GlCreateStepper can mirror this with SEATA_WIZARD_FLOW.GL_CREATE + BASE_ACCOUNT_API.
 */
import {BASE_AUDIT_API} from '@/services/api';
import {SEATA_TX_NAMES} from '@/services/seataGlobalTxConstants';
import {
    beginWizardTx,
    commitWizardTx,
    ensureWizardTxStarted,
    rollbackWizardTx,
    clearWizardTxLocal,
} from '@/services/seataGlobalTxService';
import {SEATA_WIZARD_FLOW, setActiveSeataFlow} from '@/services/seataTxHolder';

const FLOW = SEATA_WIZARD_FLOW.FS_CREATE;
const API_BASE = BASE_AUDIT_API;
const TX_NAME = SEATA_TX_NAMES.FS_CREATE_STEPPER;

export function activateFsCreateSeataFlow(): void {
    setActiveSeataFlow(FLOW);
}

export async function beginFsCreateTx(): Promise<string> {
    return beginWizardTx(FLOW, API_BASE, TX_NAME);
}

export async function ensureFsCreateTxStarted(): Promise<string> {
    return ensureWizardTxStarted(FLOW, API_BASE, TX_NAME);
}

export async function commitFsCreateTx(xid?: string | null): Promise<void> {
    await commitWizardTx(FLOW, API_BASE, xid);
}

export async function rollbackFsCreateTx(xid?: string | null): Promise<void> {
    await rollbackWizardTx(FLOW, API_BASE, xid);
}

export function clearFsCreateTxLocal(): void {
    clearWizardTxLocal(FLOW);
}
